import portal from "@vacancorp/portal";

export function sendCardImpression(
  place: portal.PublicPlaceWithVacancyId,
  placeIdHash: string,
  $gtag: any
) {
  if (place === undefined) return;
  // GA, GTM tracking
  $gtag.pageview({
    page_title: "Card impression",
    page_path: placeIdHash,
  });
}
